module.exports = __webpack_public_path__ + "img/rz.a8a4edfb.jpg";